import "../styleSheets/testimonialStyle.css";
import React, { useEffect, useState } from "react";
import { useImages } from "./useImages";

export function Reviews() {
    const review = useImages("testimonials", "id");
    const [openIndex, setOpenIndex] = useState(null);
    const [visibleIndices, setVisibleIndices] = useState([]); // 👈 track which cards are visible

    useEffect(() => {
        if (!review || review.length === 0) return;

        const elements = document.querySelectorAll(".review");

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const idx = Number(entry.target.dataset.index);
                        setVisibleIndices((prev) =>
                            prev.includes(idx) ? prev : [...prev, idx]
                        );
                        obs.unobserve(entry.target); // only once per card
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }, [review]); // rerun if review array changes

    const handleToggle = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    return (
        <div className="review_wrapper">
            {review.map((value, index) => {
                const isOpen = openIndex === index;
                const isVisible = visibleIndices.includes(index);

                return (
                    <div
                        key={value.id || index}
                        data-index={index}
                        className={`review ${isVisible ? "visible" : ""} ${isOpen ? "open" : ""}`}
                        onClick={() => handleToggle(index)}
                    >
                        <h3 className="review_title">{value.title}</h3>

                        <div className="review_body">
                            <p>{value.text}</p>
                            <p>
                                {value.author}: {value.role}
                            </p>
                            <p>{value.show}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
